// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1oTXc","content":"styles_content__dzwz-","selectAll":"styles_selectAll__3meoC"};